import { LoginSchema } from "@/forms/auth/auth.schema";

/**
 * Utility function to check if input is an email address
 */
export const isEmail = (input: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(input.trim());
};

/**
 * Validates employer code or email address input
 * Returns error message if validation fails, undefined if valid
 */
export const validateEmployerCodeOrEmail = (
  value: string | null | undefined
): string | undefined => {
  const input = value?.trim() || "";

  if (!input) {
    return "Employer code or email address is required";
  }

  if (isEmail(input)) {
    const emailResult = LoginSchema.shape.emailAddress.safeParse(input);
    return emailResult.success
      ? undefined
      : emailResult.error.issues[0]?.message || "Invalid email address";
  } else {
    const employerCodeResult = LoginSchema.shape.employerCode.safeParse(input);
    return employerCodeResult.success
      ? undefined
      : employerCodeResult.error.issues[0]?.message || "Invalid employer code";
  }
};
